export default __webpack_public_path__ + "static/media/The Unconquerable Riddle of Steel.b215b5b5.jpg";